<template>
  <!-- List Routing Popup -->
  <el-dialog
    title="Routing"
    :visible.sync="dialogRoutingVisible"
    :close-on-click-modal="false"
    width="900px"
  >
    <div class="das-form-container">
      <div class="das-form-group">
        <div class="das-form-group-title">Từ Folio</div>
        <InfoList
          :columns="3"
          :column-breakpoint-options="{
            sm: 1,
            md: 3,
            lg: 3,
            xl: 3
          }"
        >
          <InfoListLabel>Số Folio</InfoListLabel>
          <InfoListValue>{{
            customerInfo?.sub_booking_group_id
          }}</InfoListValue>

          <InfoListLabel>Tên</InfoListLabel>
          <InfoListValue>{{
            `${customerInfo?.last_name} ${customerInfo?.first_name}`.trim()
          }}</InfoListValue>

          <InfoListLabel>Số phòng</InfoListLabel>
          <InfoListValue>{{ customerInfo?.room_num }}</InfoListValue>
        </InfoList>
      </div>
    </div>
    <div class="mt-10" style="height: 400px">
      <GridVx
        ref="routingGrid"
        :columns="routingCols"
        :rows="routingRows"
        dom-layout="scroll"
        class="agGrid"
        @selectionChanged="onSelectRouting"
      />
    </div>
    <span slot="footer" class="dialog-footer">
      <div class="button-containers">
        <button
          class="btn primary small outline"
          @click="dialogRoutingVisible = false"
        >
          Đóng
        </button>
        <button
          class="btn primary small outline"
          :disabled="selectedRoutingIds.length <= 0"
          @click="onDeleteRouting"
        >
          Xóa
        </button>
        <button
          class="btn primary small"
          :disabled="selectedRoutingIds.length !== 1"
          @click="editRouting"
        >
          Sửa
        </button>
        <button class="btn primary small" @click="addRouting">Thêm</button>
      </div>
    </span>

    <!-- Add/Edit Routing Transaction -->
    <el-dialog
      title="Routing"
      :visible.sync="dialogAddRoutingVisible"
      :close-on-click-modal="false"
      width="500px"
      append-to-body
    >
      <div class="das-form-container">
        <div class="das-form-group">
          <div class="das-form-group-title">Chuyển từ</div>
          <div class="das-form-row">
            <div class="das-form-col col-12">
              <div class="das-form-input">
                <div class="das-form-input in-line">
                  <div class="label">Đặt phòng</div>
                  <span class="value">{{ customerInfo?.booking_code }}</span>
                </div>
              </div>
            </div>
          </div>
          <div class="das-form-row">
            <div class="das-form-col col-12">
              <div class="das-form-input">
                <div class="das-form-input in-line">
                  <div class="label">
                    <span class="required">Trang giao dịch</span>
                  </div>
                  <el-select
                    v-model="createRoutingForm.trans_page_org"
                    filterable
                    clearable
                    placeholder=""
                  >
                    <el-option
                      v-for="item1 in tranPageOptions"
                      :key="item1.value"
                      :label="`${item1.code} - ${item1.desc}`"
                      :value="item1.value"
                    >
                    </el-option>
                  </el-select>
                </div>
              </div>
            </div>
          </div>
          <div class="das-form-row">
            <div class="das-form-col col-12">
              <div class="das-form-input">
                <div class="das-form-input in-line">
                  <div class="label">
                    <span class="required">Mã giao dịch</span>
                  </div>
                  <el-select
                    v-model="createRoutingForm.transaction_id"
                    filterable
                    clearable
                    placeholder=""
                  >
                    <el-option :key="9999" :value="null" label="Tất cả" />
                    <el-option
                      v-for="item in transactionOptions"
                      :key="item.id"
                      :label="item.description"
                      :value="item.id"
                    >
                    </el-option>
                  </el-select>
                  <!-- <select-with-search-table
                    style="width: 100%"
                    index-field="id"
                    :search-fields="['id', 'code', 'description']"
                    :selected-index-field-value="
                      createRoutingForm.transaction_id
                    "
                    :value="createRoutingForm.transaction_id"
                    :rows="txnRows"
                    :columns="txnCols"
                    :dropdown-width="600"
                    :is-remove-btn="true"
                    @selectionChanged="onSelectTxn"
                  >
                    <template v-slot:value="{ selectedValue: selectedData }">
                      <div>
                        <span>
                          {{
                            `${selectedData?.id || ''} - ${
                              selectedData?.code || ''
                            } - ${selectedData?.description || ''}`
                          }}
                        </span>
                      </div>
                    </template>
                  </select-with-search-table> -->
                </div>
              </div>
            </div>
          </div>
          <div class="das-form-row">
            <div class="das-form-col col-12">
              <div class="das-form-input">
                <div class="das-form-input in-line">
                  <div class="label">
                    <span class="required">Mã GD phụ</span>
                  </div>
                  <el-select
                    v-model="createRoutingForm.sub_transaction_id"
                    placeholder=""
                  >
                    <el-option :key="9999" :value="null" label="Tất cả" />
                    <el-option
                      v-for="item in subTransactionOptions"
                      :key="item.id"
                      :label="item.description"
                      :value="item.id"
                    >
                    </el-option>
                  </el-select>
                  <!-- <select-with-search-table
                    style="width: 100%"
                    index-field="id"
                    :search-fields="['id', 'code', 'name']"
                    :selected-index-field-value="
                      createRoutingForm.sub_transaction_id
                    "
                    :value="createRoutingForm.sub_transaction_id"
                    :rows="subTxnRows"
                    :columns="subTxnCols"
                    :dropdown-width="600"
                    :is-remove-btn="true"
                    @selectionChanged="onSelectSubTxn"
                  >
                    <template v-slot:value="{ selectedValue: selectedData }">
                      <div>
                        <span>
                          {{
                            `${selectedData?.id || ''} - ${
                              selectedData?.code || ''
                            } - ${selectedData?.description || ''}`
                          }}
                        </span>
                      </div>
                    </template>
                  </select-with-search-table> -->
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="das-form-group">
          <div class="das-form-group-title">Chuyển đến</div>
          <div class="das-form-row">
            <div class="das-form-col col-12">
              <div class="das-form-input in-line">
                <div class="label">
                  <span class="required">Đặt phòng</span>
                </div>
                <div style="display: flex; gap: 10px; width: 100%">
                  <input
                    v-model="createRoutingForm.sub_booking_group_id_des"
                    type="text"
                    disabled
                  />
                  <das-button
                    color="primary"
                    size="small"
                    append-icon="search"
                    @click="dialogSearchFolioVisible = true"
                  />
                </div>
              </div>
            </div>
          </div>
          <div class="das-form-row">
            <div class="das-form-col col-12">
              <div class="das-form-input in-line">
                <div class="label">
                  <span class="required">Trang giao dịch</span>
                </div>
                <el-select
                  v-model="createRoutingForm.trans_page_des"
                  placeholder=""
                >
                  <el-option
                    v-for="item1 in tranPageOptions"
                    :key="item1.value"
                    :label="`${item1.code} - ${item1.desc}`"
                    :value="item1.value"
                  >
                  </el-option>
                </el-select>
              </div>
            </div>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <div class="button-containers">
          <button class="btn primary small" @click="onRoutingSubmit">
            Đồng ý
          </button>
          <button
            class="btn primary small outline"
            @click="dialogAddRoutingVisible = false"
          >
            Đóng
          </button>
        </div>
      </span>

      <!-- search folio dialog -->
      <el-dialog
        title="Tìm FOLIO để chuyển giao dịch"
        :visible.sync="dialogSearchFolioVisible"
        :close-on-click-modal="false"
        width="900px"
        append-to-body
      >
        <div class="das-form-container">
          <div class="das-form-group">
            <div class="das-form-group-title">Tìm thông tin</div>
            <hr />
            <div class="das-form-row">
              <div class="das-form-col col-6">
                <div class="das-form-input">
                  <div class="label">Tên khách</div>
                  <input v-model="searchParamsFolio.customerInfo" type="text" />
                </div>
              </div>
              <div class="das-form-col col-6">
                <div class="das-form-input">
                  <div class="label">Đoàn</div>
                  <input v-model="searchParamsFolio.groupInfo" type="text" />
                </div>
              </div>
            </div>
            <div class="das-form-row">
              <div class="das-form-col col-6">
                <div class="das-form-input">
                  <div class="label">Hạng/Số phòng</div>
                  <div style="display: flex; gap: 10px">
                    <el-select
                      v-model="searchParamsFolio.roomLevelId"
                      filterable
                      clearable
                      placeholder=""
                    >
                      <el-option :key="9999" :value="null" label="Tất cả" />
                      <el-option
                        v-for="item in roomLevelOptions"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id"
                      >
                      </el-option>
                    </el-select>

                    <el-select
                      v-model="searchParamsFolio.roomId"
                      filterable
                      clearable
                      placeholder=""
                    >
                      <el-option :key="9999" :value="null" label="Tất cả" />
                      <el-option
                        v-for="item in roomNumOptions"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id"
                      >
                      </el-option>
                    </el-select>
                  </div>
                </div>
              </div>
              <div class="das-form-col col-6">
                <div class="das-form-input">
                  <div class="das-form-input">
                    <div class="label">ID thành viên</div>
                    <input v-model="searchParamsFolio.guestNum" type="text" />
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="das-form-group">
            <div class="das-form-group-title">Tìm kiếm nâng cao</div>
            <hr />
            <div class="das-form-row">
              <div class="das-form-col col-6">
                <div class="das-form-input">
                  <div class="label">Họ</div>
                  <input
                    v-model="searchParamsFolioAdvance.last_name"
                    type="text"
                  />
                </div>
              </div>
              <div class="das-form-col col-6">
                <div class="das-form-input">
                  <div class="label">Tên</div>
                  <input
                    v-model="searchParamsFolioAdvance.first_name"
                    type="text"
                  />
                </div>
              </div>
            </div>
            <div class="das-form-row">
              <div class="das-form-col col-6">
                <div class="das-form-input">
                  <div class="label">Công ty</div>
                  <el-select
                    v-model="searchParamsFolioAdvance.agent_id"
                    placeholder=""
                  >
                    <el-option :key="9999" :value="null" label="Tất cả" />
                    <el-option
                      v-for="item in agentOptions"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id"
                    >
                    </el-option>
                  </el-select>
                </div>
              </div>
              <div class="das-form-col col-6">
                <div class="das-form-input">
                  <div class="label">Phân khúc thị trường</div>
                  <select-with-search-table
                    style="width: 100%"
                    index-field="id"
                    :search-fields="['code', 'name']"
                    :selected-index-field-value="
                      searchParamsFolioAdvance.market_seg_id
                    "
                    :value="searchParamsFolioAdvance.market_seg_id"
                    :rows="marketSegRows"
                    :columns="marketSegCols"
                    :dropdown-width="600"
                    :is-remove-btn="true"
                    @selectionChanged="onSelectMarketSeg"
                  >
                    <template v-slot:value="{ selectedValue: selectedData }">
                      <div>
                        <span>
                          {{
                            `${selectedData?.code || ''} - ${
                              selectedData?.name || ''
                            }`
                          }}
                        </span>
                      </div>
                    </template>
                  </select-with-search-table>
                </div>
              </div>
            </div>
            <div class="das-form-row">
              <div class="das-form-col col-6">
                <div class="das-form-input">
                  <div class="label">Quốc gia</div>
                  <el-select
                    v-model="searchParamsFolioAdvance.nation_id"
                    placeholder=""
                  >
                    <el-option :key="9999" :value="null" label="Tất cả" />
                    <el-option
                      v-for="item in nationOptions"
                      :key="item.id"
                      filterable
                      clearable
                      :label="item.name"
                      :value="item.id"
                    >
                    </el-option>
                  </el-select>
                </div>
              </div>
            </div>
            <div class="das-form-row">
              <div class="das-form-col col-6">
                <div class="das-form-input">
                  <div class="label">Ngày đến</div>
                  <CalendarRange
                    v-model="searchParamsFolioAdvance.arrive_date"
                    style="display: block; width: 100%"
                    mode="date"
                  />
                </div>
              </div>
              <div class="das-form-col col-6">
                <div class="das-form-input">
                  <div class="label">Ngày đi</div>
                  <CalendarRange
                    v-model="searchParamsFolioAdvance.depart_date"
                    style="display: block; width: 100%"
                    mode="date"
                  />
                </div>
              </div>
            </div>
            <!-- <div class="das-form-row">
              <div class="das-form-col col-6">
                <div class="das-form-input">
                  <div class="label">Đại lý du lịch/AR</div>
                  <input
                    v-model="searchParamsFolioAdvance.agent_id"
                    type="text"
                  />
                </div>
              </div>
            </div> -->
          </div>
          <!--
          <div class="das-form-group">
            <div class="das-form-group-title">Trạng thái đặt phòng</div>
            <hr />
            <div class="das-form-row">
              <div class="das-form-col col-12">
                <div class="checkbox-container">
                  <div class="checkbox-wrap">
                    <input
                      id="cpSpdTp20"
                      v-model="searchParamsFolioAdvance.booked"
                      type="checkbox"
                    />
                    <label for="cpSpdTp20">Đã đặt</label>
                  </div>
                  <div class="checkbox-wrap">
                    <input
                      id="cpSpdTp2"
                      v-model="searchParamsFolioAdvance.is_checked_out_today"
                      type="checkbox"
                    />
                    <label for="cpSpdTp2">Đã trả phòng hôm nay</label>
                  </div>
                  <div class="checkbox-wrap">
                    <input
                      id="cpSpdTp2"
                      v-model="searchParamsFolioAdvance.is_canceled"
                      type="checkbox"
                    />
                    <label for="cpSpdTp2">Đã hủy</label>
                  </div>
                  <div class="checkbox-wrap">
                    <input
                      id="cpSpdTp2"
                      v-model="searchParamsFolioAdvance.is_arrive_today"
                      type="checkbox"
                    />
                    <label for="cpSpdTp2">Đến hôm nay</label>
                  </div>
                  <div class="checkbox-wrap">
                    <input
                      id="cpSpdTp2"
                      v-model="searchParamsFolioAdvance.is_not_arrive"
                      type="checkbox"
                    />
                    <label for="cpSpdTp2">Không đến</label>
                  </div>
                  <div class="checkbox-wrap">
                    <input
                      id="cpSpdTp2"
                      v-model="searchParamsFolioAdvance.is_not_arrive"
                      type="checkbox"
                    />
                    <label for="cpSpdTp2">Đang ở</label>
                  </div>
                  <div class="checkbox-wrap">
                    <input
                      id="cpSpdTp2"
                      v-model="searchParamsFolioAdvance.is_checkout"
                      type="checkbox"
                    />
                    <label for="cpSpdTp2">Đã trả phòng</label>
                  </div>
                </div>
              </div>
            </div>
            <div class="das-form-row align-end">
              <div class="das-form-col col-12">
                <div class="checkbox-container">
                  <div class="checkbox-wrap">
                    <input
                      id="cpSpdTp20"
                      v-model="searchParamsFolioAdvance.is_definite"
                      type="checkbox"
                    />
                    <label for="cpSpdTp20">Definite</label>
                  </div>
                  <div class="checkbox-wrap">
                    <input
                      id="cpSpdTp2"
                      v-model="searchParamsFolioAdvance.is_waiting"
                      type="checkbox"
                    />
                    <label for="cpSpdTp2">Waiting</label>
                  </div>
                  <div class="checkbox-wrap">
                    <input
                      id="cpSpdTp2"
                      v-model="searchParamsFolioAdvance.is_tentative"
                      type="checkbox"
                    />
                    <label for="cpSpdTp2">Tentatvie</label>
                  </div>
                  <div class="checkbox-wrap">
                    <input
                      id="cpSpdTp2"
                      v-model="searchParamsFolioAdvance.exactly"
                      type="checkbox"
                    />
                    <label for="cpSpdTp2">Chính xác</label>
                  </div>
                </div>
              </div>
            </div>
          </div> -->
        </div>
        <span slot="footer" class="dialog-footer">
          <div class="button-containers">
            <button
              class="btn primary small"
              @click="dialogSearchFolioVisible = false"
            >
              Đóng
            </button>
            <button class="btn primary small" @click="searchFolio">
              Tìm kiếm
            </button>
            <button class="btn primary small" @click="searchFolioAdvance">
              Tìm kiếm nâng cao
            </button>
          </div>
        </span>
      </el-dialog>

      <!-- list folio dialog -->
      <el-dialog
        title="Tìm FOLIO để chuyển giao dịch"
        :visible.sync="dialogListFolioVisible"
        :close-on-click-modal="false"
        width="900px"
        append-to-body
      >
        <div class="mt-10" style="height: 400px">
          <GridVx
            ref="folioListGrid"
            dom-layout="scroll"
            :columns="folioListCols"
            :rows="folioListRows"
            row-selection="single"
            class="agGrid"
            @selectionChanged="onSelectionChanged"
          />
        </div>
        <span slot="footer" class="dialog-footer">
          <div class="button-containers">
            <button
              class="btn primary small outline"
              @click="dialogListFolioVisible = false"
            >
              Đóng
            </button>
            <button
              class="btn primary small"
              :disabled="!selectedFolio"
              @click="onFolioSelect"
            >
              Chọn
            </button>
          </div>
        </span>
      </el-dialog>
    </el-dialog>
  </el-dialog>
</template>

<script>
import { getSubTransactionListSimpleApi } from '@/api/Transaction/subTransaction'
import {
  getRoutingList,
  postRouting,
  searchFolioAdvanceApi,
  searchFolioApi,
  deleteRouting
} from '@/api/cashier_service/postTransaction'
import { getNationListApi } from '@/api/common/code'
import { getCodeBase } from '@/api/common/code_base'
import { getTransactionListApi } from '@/api/common/transaction'
import { getAgentSimpleListApi } from '@/api/configuration/profile/agent'
import { getMarketSeg, getRoom, getRoomLevel } from '@/api/reception/common'
import DasButton from '@/components/ui/DasButton.vue'
import CalendarRange from '@/components/CalendarSelect/CalendarRange.vue'
import { notifyError } from '@/utils/toast'

export default {
  components: {
    DasButton,
    CalendarRange
  },
  props: {
    value: {
      type: Boolean
    },
    customerInfo: {
      type: Object
    }
  },
  data() {
    return {
      routingRows: [],
      routingCols: [
        {
          headerName: this.$t('grid.column.fromPageTransaction'),
          field: 'trans_page_org_code'
        },
        {
          headerName: this.$t('grid.column.transactionCode'),
          field: 'sub_booking_group_des_code'
        },
        {
          headerName: this.$t('grid.column.subTransactionCode'),
          field: 'sub_transaction_code'
        },
        {
          headerName: this.$t('grid.column.toFolio'),
          field: 'trans_page_des_code'
        },
        {
          headerName: this.$t('grid.column.toPageTransaction'),
          field: 'trans_page_org_code'
        },
        {
          headerName: this.$t('grid.column.toRoom'),
          field: 'transaction_code'
        }
      ],
      selectedRoutingIds: [],
      selectedRouting: null,

      // sub dialog
      dialogAddRoutingVisible: false,
      dialogSearchFolioVisible: false,
      dialogListFolioVisible: false,

      // add routing dialog
      createRoutingForm: {
        sub_booking_group_id_org: null,
        trans_page_org: null,
        transaction_id: null,
        sub_transaction_id: null,
        trans_page_des: null,
        sub_booking_group_id_des: null,
        sub_booking_group_name_des: null,
        sub_booking_group_des_code: null
      },
      defaultCreateRoutingForm: {
        sub_booking_group_id_org: null,
        trans_page_org: null,
        transaction_id: null,
        sub_transaction_id: null,
        trans_page_des: null,
        sub_booking_group_id_des: null,
        sub_booking_group_name_des: null,
        sub_booking_group_des_code: null
      },

      // select
      tranPageOptions: [],
      transactionOptions: [],
      subTransactionOptions: [],
      txnRows: [],
      txnCols: [
        { headerName: 'ID', field: 'id', tooltipField: 'id' },
        { headerName: 'Mã', field: 'code', tooltipField: 'code' },
        {
          headerName: 'Mô tả',
          field: 'description',
          tooltipField: 'description'
        }
      ],
      subTxnRows: [],
      subTxnCols: [
        { headerName: 'ID', field: 'id', tooltipField: 'id' },
        { headerName: 'Mã', field: 'code', tooltipField: 'code' },
        {
          headerName: 'Mô tả',
          field: 'description',
          tooltipField: 'description'
        }
      ],

      // folio search dialog
      searchParamsFolio: {
        customerInfo: null,
        groupInfo: null,
        roomLevelId: null,
        roomId: null,
        guestNum: null
      },
      searchParamsFolioAdvance: {
        first_name: null,
        last_name: null,
        price_code_id: null,
        arrive_date_from: null,
        arrive_date_to: null,
        arrive_date: {
          start: null,
          end: null
        },
        depart_date_from: null,
        depart_date_to: null,
        depart_date: {
          start: null,
          end: null
        },
        agent_name: null,
        agent_id: null,
        nation_id: null,
        market_seg_id: null,
        booked: null,
        is_arrive_today: null,
        is_not_checkout: null,
        is_checked_out_today: null,
        is_checkout: null,
        is_canceled: null,
        is_not_arrive: null,
        is_definite: null,
        is_tentative: null,
        is_waiting: null,
        exactly: null
      },
      roomLevelOptions: [],
      roomNumOptions: [],
      agentOptions: [],
      nationOptions: [],
      marketSegRows: [],
      marketSegCols: [
        { headerName: 'Mã', field: 'code', tooltipField: 'code' },
        {
          headerName: 'Tên',
          field: 'name',
          tooltipField: 'name'
        }
      ],

      // folio list dialog
      folioListRows: [],
      folioListCols: [
        {
          headerName: this.$t('grid.column.reservation'),
          field: 'room_code',
          width: 150
        },
        {
          headerName: this.$t('grid.column.name'),
          field: 'full_name',
          width: 150
        },
        // {
        //   headerName: this.$t('grid.column.price'),
        //   field: 'invoice_num',
        //   width: 150
        // },
        {
          headerName: this.$t('grid.column.room'),
          field: 'room_num'
        },
        {
          headerName: this.$t('grid.column.roomLevel'),
          field: 'room_level',
          width: 150
        },
        {
          headerName: this.$t('grid.column.comeDate'),
          field: 'arrive_date',
          width: 150
        },
        {
          headerName: this.$t('grid.column.departDate'),
          field: 'depart_date',
          width: 150
        },
        {
          headerName: 'NL/TE',
          field: 'adult_and_child',
          width: 150,
          valueGetter(params) {
            const data = params.data
            return data.nl + '/' + data.te
          }
        },
        {
          headerName: this.$t('grid.column.group'),
          field: 'group_code',
          width: 150
        },
        {
          headerName: this.$t('grid.column.company'),
          field: 'agent_name',
          width: 150
        }
      ],
      selectedFolio: null
    }
  },
  computed: {
    dialogRoutingVisible: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    }
  },

  watch: {
    customerInfo(nv, ov) {
      this.onOpenRoutingDialog(nv)
    },
    async 'createRoutingForm.transaction_id'(nv, ov) {
      await this.getSubTranByTranId(nv)
    }
  },

  async mounted() {
    await Promise.all([
      this.getAllTranPage(),
      this.getAllTran(),
      this.getAllRoomLevel(),
      this.getAllRoomNum(),
      this.getAllAgent(),
      this.getAllMarketSeg(),
      this.getAllNation()
    ]).catch(error => {
      const message = error.response?.data?.message
      notifyError(message)
    })
  },

  methods: {
    // ==== routing dialog === //
    // handle event
    onSelectTxn(data) {
      this.createRoutingForm.transaction_id = data?.id || null
    },
    onSelectSubTxn(data) {
      this.createRoutingForm.sub_transaction_id = data?.id || null
    },
    addRouting() {
      this.createRoutingForm = { ...this.defaultCreateRoutingForm }
      this.dialogAddRoutingVisible = true
    },
    editRouting() {
      // if (!this.checkRoutingGridRowSelected()) return

      this.createRoutingForm = { ...this.selectedRouting }
      this.dialogAddRoutingVisible = true
    },
    onSelectRouting(selectedRows) {
      this.selectedRouting = selectedRows[0]
      this.selectedRoutingIds =
        selectedRows.length > 0 ? selectedRows.map(item => item.id) : []
    },
    onDeleteRouting() {
      this.fnDeleteRouting()
      // if (!this.checkRoutingGridRowSelected()) return
      // this.$message({
      //   message: 'Xóa thành công',
      //   type: 'success'
      // })
    },

    // ==== folio search dialog === //
    searchFolio() {
      this.fnSearchFolio()
    },
    searchFolioAdvance() {
      this.fnSearchFolioAdvance()
    },
    onSelectMarketSeg(data) {
      this.searchParamsFolioAdvance.market_seg_id = data?.id || null
    },

    // ==== folio list dialog ==== //
    onSelectionChanged(selectedRows) {
      this.selectedFolio = selectedRows[0]
    },
    onFolioSelect() {
      this.createRoutingForm.sub_booking_group_id_des = this.selectedFolio?.name
      console.debug(this.selectedFolio)
      this.dialogListFolioVisible = false
    },

    // ===================================== handle api ============================
    // routing dialog
    async onOpenRoutingDialog(info) {
      const data = await getRoutingList(info?.sub_booking_group_id)
      this.routingRows = data?.data || []
    },
    async onRoutingSubmit() {
      this.createRoutingForm.sub_booking_group_id_org = this.customerInfo.id
      // await postRouting(this.createRoutingForm).then(() => {
      //   this.dialogAddRoutingVisible = false
      // })

      postRouting(this.createRoutingForm)
        .then(data => {
          if (!data.is_error) {
            this.$message({
              message: data.message,
              type: 'success'
            })

            this.onOpenRoutingDialog(this.customerInfo)
          } else {
            throw new Error(data)
          }
        })
        .catch(error => {
          this.$message({
            message: this.$t('errorMsg.' + error.response?.data?.message),
            type: 'error'
          })
        })
        .finally(() => {
          this.dialogAddRoutingVisible = false
        })
    },
    async fnDeleteRouting() {
      this.$vxConfirm('Xác nhận xóa routing?', () => {
        deleteRouting(this.selectedRoutingIds)
          .then(data => {
            if (!data.is_error) {
              this.$message({
                message: data.message,
                type: 'success'
              })

              this.onOpenRoutingDialog(this.customerInfo)
            } else {
              throw new Error(data)
            }
          })
          .catch(error => {
            this.$message({
              message: error.response?.data?.message,
              type: 'error'
            })
          })
          .finally(() => {})
      })
    },
    async getAllTranPage() {
      try {
        const data = await getCodeBase({
          p_code: 'TRANPAGE'
        })
        this.tranPageOptions = data.data.map(item => {
          return {
            value: item.id,
            label: item.code,
            ...item
          }
        })

        if (!this.defaultCreateRoutingForm.trans_page_org) {
          this.defaultCreateRoutingForm.trans_page_org =
            this.tranPageOptions[0]?.value
        }

        if (!this.defaultCreateRoutingForm.trans_page_des) {
          this.defaultCreateRoutingForm.trans_page_des =
            this.tranPageOptions[0]?.value
        }
      } catch (error) {
        const message = error.response?.data?.message
        notifyError(message)
      } finally {
        //
      }
    },
    async getAllTran() {
      try {
        const data = await getTransactionListApi({ transactionGroup: 0 })
        this.transactionOptions = data?.data.filter(
          item => !item.transaction_group_name
        )
        this.txnRows = data?.data.filter(item => !item.transaction_group_name)
      } catch (error) {
        //
        this.$message({
          message: error.response?.data?.message,
          type: 'error'
        })
      } finally {
        //
      }
    },
    async getSubTranByTranId(tranId) {
      try {
        const data = await getSubTransactionListSimpleApi({
          transactionId: tranId
        })
        this.subTransactionOptions = data?.data
        this.subTxnRows = data?.data
      } catch (error) {
        this.$message({
          message: error.response?.data?.message,
          type: 'error'
        })
      } finally {
        //
      }
    },

    // search folio
    async getAllRoomLevel() {
      try {
        const data = await getRoomLevel()
        this.roomLevelOptions = data.data.map(item => {
          return {
            id: item.id,
            name: item.name
          }
        })
      } catch (error) {
        this.$message({
          message: error.response?.data?.message,
          type: 'error'
        })
      } finally {
        //
      }
    },
    async getAllRoomNum() {
      try {
        const data = await getRoom()
        this.roomNumOptions = data.data.map(item => {
          return {
            id: item.id,
            name: item?.room_num
          }
        })
      } catch (error) {
        this.$message({
          message: error.response?.data?.message,
          type: 'error'
        })
      } finally {
        //
      }
    },
    async getAllAgent() {
      try {
        const data = await getAgentSimpleListApi()
        this.agentOptions = data.data.map(item => {
          return {
            id: item.id,
            name: item.name
          }
        })
      } catch (error) {
        this.$message({
          message: error.response?.data?.message,
          type: 'error'
        })
      } finally {
        //
      }
    },
    async getAllMarketSeg() {
      try {
        const data = await getMarketSeg({
          isActive: 1
        })
        this.marketSegRows = data.data.map(item => {
          return {
            id: item.id,
            name: item.desc,
            code: item.code
          }
        })
      } catch (error) {
        this.$message({
          message: error.response?.data?.message,
          type: 'error'
        })
      } finally {
        //
      }
    },
    async getAllNation() {
      try {
        const data = await getNationListApi()
        this.nationOptions = data.data.map(item => {
          return {
            id: item.id,
            name: item.desc
          }
        })
      } catch (error) {
        this.$message({
          message: error.response?.data?.message,
          type: 'error'
        })
      } finally {
        //
      }
    },
    // search folio
    fnSearchFolio() {
      searchFolioApi(this.searchParamsFolio)
        .then(res => {
          this.folioListRows = res.data
          this.dialogListFolioVisible = true
        })
        .catch(error => {
          this.$message({
            message: error.response?.data?.message,
            type: 'error'
          })
        })
        .finally(() => {})
    },
    fnSearchFolioAdvance() {
      searchFolioAdvanceApi({
        ...this.searchParamsFolioAdvance,
        arrive_date_from: this.searchParamsFolioAdvance.arrive_date.start,
        arrive_date_to: this.searchParamsFolioAdvance.arrive_date.end,
        depart_date_from: this.searchParamsFolioAdvance.depart_date.start,
        depart_date_to: this.searchParamsFolioAdvance.depart_date.end
      })
        .then(res => {
          this.folioListRows = res.data
          this.dialogListFolioVisible = true
        })
        .catch(error => {
          this.$message({
            message: error.response?.data?.message,
            type: 'error'
          })
        })
        .finally(() => {})
    }
  }
}
</script>
